export default {
  pricingIndex: {
    LIVE_RATES: {
      en: 'Live Rates',
      zh: '公司名'
    }
  }
};
